import { omit } from 'lodash-es';
import { ReactText } from 'react';

const baseHeaders = ['cache-control', 'content-length', 'content-type'];
/**
 * function will split headers from into x, category,status,'count'., and categorieze them to proper category
 * Also basic headers like cache-control, content-length and content-type will be discarted
 * one special header total-count, will be returned as it is, count part won't be deleted
 * @param headers from axios api call
 * @returns object in form {...,category: [headerOfuscatedName]: value,...}
 */

export const headersParser = (headers?: Record<string, ReactText>): Record<string, number> => {
    const customHeaders = omit(headers, baseHeaders);

    return Object.keys(customHeaders)?.reduce((acc, header: string) => {
        const [, category, status] = header?.split('-');

        if (!category && !status) {
            return acc;
        }

        return { ...acc, [category]: { ...acc?.[category], [status]: +headers?.[header] } };
    }, {});
};
